import React, { useState, useEffect, useRef } from 'react'
import logo from '../assets/navbar/MicroDegree-RIIDL-Logo.webp'
import { SearchIcon, PhoneIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/solid'
import { Courses } from '../Courses'
import { Demo } from './Demo'
import Modal from './Modal'
import Flag from '../assets/navbar/Ny.webp'

function Navbar({ setSearchedResults }) {
  const [dropDown, setDropDown] = useState(false);
  const dropdownRef = useRef(null);
  const [dropDown1, setDropDown1] = useState(false);
  const dropdownRef1 = useRef(null);
  const [isToolsOpen, setIsToolsOpen] = useState(false);
  const [viewModal, setViewModal] = useState(false);

  // NEW STATES FOR MOBILE DROPDOWNS
  const [coursesOpen, setCoursesOpen] = useState(false);
  const [toolsMobileOpen, setToolsMobileOpen] = useState(false);
  const [demoMobileOpen, setDemoMobileOpen] = useState(false);

  const desktopCtas = [
    {
  label: (
    <>
      Tech. <span className="font-['Anek_Kannada'] font-semibold">ಹರಟೆ</span>
    </>
  ),
  href: "https://techharate.in/",
  external: true,
},
    {
      label: "Jobs",
      href: "https://portal.microdegree.work",
      external: true,
    },
    //     {
    //   label: "Careers",
    //   href: "https://careers.microdegree.work",
    //   external: true,
    // },
  ];

  // Detect clicks outside dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropDown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Detect clicks outside dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
        setDropDown1(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Sidebar open/close logic
  useEffect(() => {
    const sidebar = document.getElementById("sidebar");
    const openSidebarButton = document.getElementById("open-sidebar");

    if (!sidebar || !openSidebarButton) {
      return undefined;
    }

    const handleOpenSidebar = (e) => {
      e.stopPropagation();
      sidebar.classList.toggle("-translate-x-full");
    };

    const handleCloseSidebar = (e) => {
      if (
        !sidebar.contains(e.target) &&
        !openSidebarButton.contains(e.target)
      ) {
        sidebar.classList.add("-translate-x-full");
      }
    };

    openSidebarButton.addEventListener("click", handleOpenSidebar);
    document.addEventListener("click", handleCloseSidebar);

    return () => {
      openSidebarButton.removeEventListener("click", handleOpenSidebar);
      document.removeEventListener("click", handleCloseSidebar);
    };
  }, []);

  // Tools dropdown outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".tools-dropdown")) {
        setIsToolsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div>
      <header className="w-full shadow-sm">
        <div className="mx-auto flex h-20 w-full max-w-screen-2xl items-center justify-between px-4 sm:px-6 lg:px-10">
          <a href="https://www.microdegree.work/" className="flex items-center">
            <img
              className="min-w-[200px] max-w-[200px] md:min-w-[190px] md:max-w-[190px] 2xl:min-w-[230px] 2xl:max-w-[230px]"
              src={logo}
              width="460"
              height="83"
              alt="MicroDegree Logo"
              loading="lazy"
            />
          </a>

          <div className="hidden xl:flex flex-wrap items-center justify-end gap-x-4 gap-y-2 xl:gap-x-6 ml-auto pl-4">
            <div className="relative" ref={dropdownRef}>
              <button
                type="button"
                className="flex items-center gap-2 rounded-full px-3 py-2 text-sm xl:text-base font-medium text-gray-700 transition hover:bg-[#FF2A67]/10 hover:text-[#FF2A67]"
                onClick={() => setDropDown((prev) => !prev)}
              >
                <span>Courses</span>
                {dropDown ? (
                  <ChevronUpIcon className="h-4 w-4" />
                ) : (
                  <ChevronDownIcon className="h-4 w-4" />
                )}
              </button>

              <div
                className={`absolute left-0 top-full mt-3 w-96 text-left rounded-xl bg-white shadow-xl transition duration-200 z-[60] ${
                  dropDown ? "opacity-100" : "pointer-events-none opacity-0"
                }`}
              >
                {Courses.map((item, index) => (
                  <a
                    href={item.course_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    key={item.id}
                    className={`block px-5 py-3 text-sm font-medium text-gray-700 transition hover:bg-[#FF2A67] hover:text-white ${
                      index === Courses.length - 1 ? "mb-4" : ""
                    }`}
                  >
                    {item.course_name}
                  </a>
                ))}
              </div>
            </div>

            <div className="relative tools-dropdown">
              <button
                type="button"
                className="flex items-center gap-1 rounded-full px-3 py-2 text-sm xl:text-base font-medium text-gray-700 transition hover:bg-[#FF2A67]/10 hover:text-[#FF2A67]"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsToolsOpen((prev) => !prev);
                }}
              >
                <span>Tools</span>
                <svg
                  className={`h-3 w-3 transition ${
                    isToolsOpen ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {isToolsOpen && (
                <div className="absolute right-0 top-full mt-3 w-80 rounded-xl bg-white py-2 text-left shadow-xl z-[60]">
                  {/* Free Demo (moved from top-level nav) */}
                  <div className="relative" ref={dropdownRef1}>
                    <button
                      type="button"
                      className="flex w-full items-center justify-between px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#FF2A67] hover:text-white"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDropDown1((prev) => !prev);
                      }}
                    >
                      <span>Free Demo</span>
                      {dropDown1 ? (
                        <ChevronUpIcon className="h-4 w-4" />
                      ) : (
                        <ChevronDownIcon className="h-4 w-4" />
                      )}
                    </button>

                    {dropDown1 && (
                      <div className="bg-gray-50">
                        {Demo.map((item) => (
                          <a
                            href={item.course_link}
                            target="_blank"
                            rel="noopener noreferrer"
                            key={item.id}
                            className="block px-8 py-2 text-sm font-medium text-gray-600 transition hover:bg-[#FF2A67] hover:text-white"
                          >
                            {item.course_name}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>

                  <a
                    href="https://www.microdegree.work/learning"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#FF2A67] hover:text-white"
                  >
                    E-Learning
                  </a>

                  {/* Tech. ಹರಟೆ & Jobs (moved from top-level nav) */}
                  {desktopCtas.map((cta) => (
                    <a
                      key={cta.label}
                      href={cta.href}
                      target={cta.external ? "_blank" : undefined}
                      rel={cta.external ? "noopener noreferrer" : undefined}
                      className="block px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#FF2A67] hover:text-white"
                    >
                      {cta.label}
                    </a>
                  ))}

                  <a rel="noopener" target="_blank" href="/blog">
                    <p className="px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#FF2A67] hover:text-white">
                      Blogs
                    </p>
                  </a>
                                    <a rel="noopener" target="_blank" href="https://resources.microdegree.work/resources?utm_source=navbar">
                    <p className="px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#FF2A67] hover:text-white">
                      Resources
                    </p>
                  </a>
<a rel="noopener" target="_blank" href="https://play.google.com/store/apps/details?id=work.microdegree.trainings&hl=en_IN">
  <p className="px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#FF2A67] hover:text-white flex items-center gap-2">
    Mobile App
  </p>
</a>
{/* <a target="_blank" href="https://talent.microdegree.work">
  <p className="px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#FF2A67] hover:text-white flex items-center gap-2">
    Hire Me Now
  </p>
</a> */}
                  {/* <a target="_blank" href="/prime">
                    <p className="px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#FF2A67] hover:text-white">
                      Prime
                    </p>
                  </a> */}
                  <a rel="noopener" target="_blank" href="/it-salary-growth-calculator">
                    <p className="px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#FF2A67] hover:text-white">
                      IT Salary Growth Calculator
                    </p>
                  </a>
                  <a rel="noopener" target="_blank" href="/interviewquestions">
                    <p className="px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#FF2A67] hover:text-white">
                      Cloud & DevOps Interview Questions
                    </p>
                  </a>
                </div>
              )}
            </div>
          </div>

          <div className="hidden xl:flex items-center gap-4 text-sm xl:text-base ml-8">
            <a
              href="tel:08047109999"
              className="flex items-center gap-2 rounded-full border border-gray-200 px-3 py-2 font-medium text-gray-700 transition hover:border-[#FF2A67] hover:text-[#FF2A67]"
            >
              <PhoneIcon className="h-4 w-4" /> 0804-710-9999
            </a>
            <a
              href="https://courses.microdegree.work/users/sign_in"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full border border-gray-300 px-4 py-2 font-semibold text-gray-800 transition hover:border-[#FF2A67] hover:text-[#FF2A67] ml-4"
            >
              Login
            </a>
          </div>

          <div className="flex shrink-0 items-center gap-4 xl:hidden">
            <a
              href="https://courses.microdegree.work/users/sign_in"
              className="text-base font-medium text-[#4159ec]"
            >
              Login
            </a>

            <button
              type="button"
              className="flex items-center justify-center rounded-md p-2 text-gray-800"
              id="open-sidebar"
              aria-label="Open navigation menu"
              aria-controls="sidebar"
            >
              <svg
                className="h-8 w-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </header>

{/* 🔴 Moving Banner */}
      <div className="w-full bg-red-500 py-1 overflow-hidden relative">
        <div className="marquee-ka flex whitespace-nowrap items-center">
          <span className="text-white font-semibold text-center px-8 flex items-center gap-2">
            Join Our Free Masterclass & Learn from Industry Experts! 🚀 |{" "}
            <a
              href="https://resources.microdegree.work/resources/masterclass/masterclass?utm_source=navbar"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-white hover:text-yellow-200"
            >
              Register For FREE
            </a>
          </span>
          {/* Dasara Dhamaka marquee (temporarily disabled)
          <span className="text-white font-semibold text-center px-8 flex items-center gap-2">
            🪔 Dasara Dhamaka is here! Spin, win and level up your career 🎉 |{" "}
            <a
              href="https://resources.microdegree.work/resources?utm_source=DDNV"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-white hover:text-yellow-200"
            >
              Spin to win
            </a>
          </span>
          */}
        </div>

        <style>
          {`
          .marquee-ka {
            animation: marquee-ka 25s linear infinite;
          }
          .marquee-ka:hover { animation-play-state: paused; }
          @media (max-width: 640px) {
            .marquee-ka {
              animation: marquee-ka 15s linear infinite;
            }
          }
          @keyframes marquee-ka {
            0% { transform: translateX(100%); }
            100% { transform: translateX(-100%); }
          }
        `}
        </style>
      </div>

        {/* Banner  Courses
Join Free Webinar 🚀 - Career Roadmap for DevOps Engineer! | Register Now*/}
      {/* <section style={{ backgroundColor: "#FF0049", textAlign: "center" }}>
        <div className="hidden sm:block text-center font-semibold">
          <a href="https://www.microdegree.work/offline" target="_blank" rel="noopener noreferrer">
            <h6 className='text-2xl flex justify-center items-center' style={{ color: "#fff", fontSize: "16px" }}>
              Exclusive Offline Masterclass on Cloud, DevOps & Generative AI🚀 |&nbsp;&nbsp;
              <span><u>Register For FREE <i className="fa fa-angle-double-right"></i></u></span>
            </h6>
          </a>
        </div>
        <div className="block sm:hidden font-semibold">
          <a href="https://www.microdegree.work/offline" target="_blank" rel="noopener noreferrer">
            <h6 className='text-xs flex justify-center items-center' style={{ color: "#fff", fontSize: "16px" }}>
              Join Offline Masterclass 🚀|&nbsp;&nbsp;
              <span><u>Register For Free <i className="fa fa-angle-double-right"></i></u></span>
            </h6>
          </a>
        </div>
      </section> */}

      {/* ========================= MOBILE SIDEBAR ========================= */}
      <div
        className="absolute bg-white text-gray-500 w-56 min-h-screen overflow-y-auto transition-transform transform -translate-x-full ease-in-out duration-300"
        style={{ zIndex: 100 }}
        id="sidebar"
      >
        <div className="p-4">
          <ul className="mt-4 text-left">
            {/* 🔽 Courses Dropdown */}
            <li className="mb-2">
              <button
                className="flex justify-between items-center w-full font-medium text-lg hover:text-[#FF2A67]"
                onClick={() => setCoursesOpen(!coursesOpen)}
              >
                <span>Courses</span>
                <span>{coursesOpen ? "▲" : "▼"}</span>
              </button>

              {coursesOpen && (
                <ul className="pl-3 mt-2 space-y-1">
                  {Courses.map((item) => (
                    <li key={item.id}>
                      <a rel="noopener"
                        href={item.course_link}
                        target="_blank"
                        className="block text-base py-1 hover:text-[#FF2A67]"
                      >
                        {item.course_name}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </li>

            {/* <li className="mb-2">
              <a
                href="https://www.microdegree.work/demopage"
                className="font-medium text-lg block hover:text-[#FF2A67]"
              >
                Free Demo
              </a>
            </li> */}
            {/* <li className="mb-2">
              <a
                href="https://www.microdegree.work/webinar"
                className="font-medium text-lg block hover:text-[#FF2A67]"
              >
                Free Webinar
              </a>
            </li> */}
            {/* <li className="mb-2">
              <a
                href="/YTFullCoursePage"
                className="font-medium text-lg block py-1 hover:text-[#FF2A67]"
              >
                Free Courses
              </a>
            </li> */}
            {/* <li className="mb-2">
              <a
                href="https://careers.microdegree.work"
                className="font-medium text-lg block hover:text-[#FF2A67]"
              >
                Careers
              </a>
            </li> */}
            {/* 🔽 Tools Dropdown */}
            <li className="mb-2">
              <button
                className="flex justify-between items-center w-full font-medium text-lg hover:text-[#FF2A67]"
                onClick={() => setToolsMobileOpen(!toolsMobileOpen)}
              >
                <span>Tools</span>
                <span>{toolsMobileOpen ? "▲" : "▼"}</span>
              </button>

              {toolsMobileOpen && (
                <ul className="pl-3 mt-2 space-y-1">
                  <li>
                    <a
                      href="https://techharate.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex py-1 items-center gap-2 hover:text-[#FF2A67]"
                    >
                      Tech. <span className="font-semibold">ಹರಟೆ</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.microdegree.work/learning"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex py-1 items-center gap-2 hover:text-[#FF2A67]"
                    >
                      E-Learning
                    </a>
                  </li>
                  {/* 🔽 Demo Dropdown (moved inside Tools) */}
                  <li>
                    <button
                      className="flex justify-between items-center w-full py-1 hover:text-[#FF2A67]"
                      onClick={() => setDemoMobileOpen(!demoMobileOpen)}
                    >
                      <span>Free Demo</span>
                      <span>{demoMobileOpen ? "▲" : "▼"}</span>
                    </button>

                    {demoMobileOpen && (
                      <ul className="pl-3 mt-1 space-y-1">
                        <li>
                          <a href="https://www.microdegree.work/demopage?utm_source=website&utm_medium=organic&utm_campaign=demo_page&utm_content=navbar_form" className="block py-1 hover:text-[#FF2A67]">
                            Cloud & DevOps Free Demo
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.microdegree.work/genaidemo"
                            className="block py-1 hover:text-[#FF2A67]"
                          >
                            Generative AI Free Demo
                          </a>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li>
                    <a
                      href="https://portal.microdegree.work/"
                      className="block py-1 hover:text-[#FF2A67]"
                    >
                      Jobs
                    </a>
                  </li>
                  <li>
                    <a href="/blog" className="block py-1 hover:text-[#FF2A67]">
                      Blogs
                    </a>
                  </li>
                                    <li>
                    <a href="https://resources.microdegree.work/resources?utm_source=navbar" className="block py-1 hover:text-[#FF2A67]">
                      Resources
                    </a>
                  </li>
                   <li>
                    <a href="https://play.google.com/store/apps/details?id=work.microdegree.trainings" className="block py-1 hover:text-[#FF2A67]">
                      Mobile App
                    </a>
                  </li>
                                                                        <li>
                    {/* <a href="/prime" className="block py-1 hover:text-[#FF2A67]">
                      Prime
                    </a> */}
                  </li>
                  <li>
                    <a
                      href="/it-salary-growth-calculator"
                      className="block py-1 hover:text-[#FF2A67]"
                    >
                      IT Salary Calculator
                    </a>
                  </li>
                  <li>
                    <a
                      href="/interviewquestions"
                      className="block py-1 hover:text-[#FF2A67]"
                    >
                      Interview Questions
                    </a>
                  </li>
                </ul>
              )}
            </li>

            {/* ------------------ REMAINING SIDEBAR ITEMS (unchanged) ------------------ */}

            {/* <li className="mb-2"><a href="https://www.microdegree.work/awsdevops" className="font-medium text-lg block hover:text-[#FF2A67]">Cloud & DevOps</a></li>
            <li className="mb-2"><a href="https://www.microdegree.work/genai" className="font-medium text-lg block hover:text-[#FF2A67]">Generative AI</a></li>
            <li className="mb-2"><a href="https://www.microdegree.work/webinar" className="font-medium text-lg block hover:text-[#FF2A67]">Webinar</a></li>
            
            <li className="mb-2"><a href="https://play.google.com/store/apps/details?id=work.microdegree.trainings" className="font-medium text-lg block hover:text-[#FF2A67]">Mobile App</a></li>
            <li className="mb-2"><a href="/it-salary-growth-calculator" className="font-medium text-lg block hover:text-[#FF2A67]">IT Salary Growth Calculator</a></li>
            <li className="mb-2"><a href="https://www.microdegree.work/company_vacancies" className="font-medium text-lg block hover:text-[#FF2A67]">DevOps Jobs</a></li>
            <li className="mb-2"><a href="/interviewquestions" className="font-medium text-lg block hover:text-[#FF2A67]">Cloud & DevOps Interview Questions</a></li> */}
            <li className="mb-2">
              <a
                href="https://courses.microdegree.work/users/sign_in"
                className="font-medium text-lg block hover:text-[#FF2A67] text-[#4159ec]"
              >
                Login
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Navbar